import Crud from "../Crud";
import { cyan } from "@mui/material/colors";

/**
 * Static helper functions related to Fee Schedule.
 */
export default class FeeSchedule extends Crud {
  /**
   * @param {object} feeSchedule The feeSchedule object.
   * @returns The display name of the feeSchedule.
   */
  static getDisplayName(feeSchedule) {
    return feeSchedule.hcpcsCode;
  }

  /**
   * Determines if an feeSchedule matches a search query.
   *
   * @param {object} feeSchedule The feeSchedule to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the feeSchedule matches the query.
   */
  static match(feeSchedule, query) {
    return (
      feeSchedule.hcpcsCode.toLowerCase().includes(query) ||
      feeSchedule.id === +query
    );
  }

  /**
   * @param {array} feeSchedules The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(feeSchedules) {
    return feeSchedules.sort((a, b) => {
      return a.id - b.id;
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return cyan;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Workspaces";
  }
}
